import COLORS from '../../style/universal.color';
import { MLBTheme } from '../../style/theme.types';
import DefaultProps from '../../commonTypes/defaultprops.types';
import React from 'react';
import Handler from '../../commonTypes/handler.types';

export interface TextInputProps extends DefaultProps {
    placeHolder?: string;
    theme?: MLBTheme;
    type?: TextInputTypes;
    handlers?: Handler;
    resetHandlers?: Handler;
    value?: string;
    refElement?: React.Ref<HTMLInputElement>;
    cancelButton?: boolean;
    iconType?: string;
    iconColor?: string;
    required?: boolean;
    inputType?: string;
    ariaLabelReset? : string;
    additionalProps?: object;
    cancelButtonRef?: React.Ref<HTMLButtonElement>;
    spellCheck?: boolean;
}

// Types used for Styling the text input
export enum TextInputTypes {
    PRIMARY = 'primary',
    DARK = 'dark'
}

export interface CloseIconProps {
    type: 'reset';
    className?: string;
    'aria-label'?: string;
    theme?: string;
    ref?: React.Ref<HTMLButtonElement>;
}

export interface IconWrapperProps {
    className?: string;
}

export const TextInputColors: object = {
    primary: {
        base: COLORS.mlbWhite,
        border: COLORS.mlbGrey6,
        text: COLORS.mlbGrey3,
        icon: COLORS.mlbGrey6
    },
        dark: {
        base: COLORS.mlbGrey6,
        border: COLORS.mlbGrey6,
        text: COLORS.mlbGrey3,
        icon: COLORS.mlbWhite
    }
}
